import React, { forwardRef } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Box, { BoxProps } from '@mui/material/Box';
// routes
import { RouterLink } from 'src/routes/components';

import logoHeader from 'src/assets/logo_header_inverted.svg';
import logoHeaderExamico from 'src/assets/examico_logo_header_inverted.svg';
import Badge, {badgeClasses} from "@mui/material/Badge";
import Label from "../label";
import {getServerName} from "../../utils/serverName";

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
  wdth?: number;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, width, sx, ...other }, ref) => {
    const theme = useTheme();

    const PRIMARY_LIGHT = theme.palette.primary.light;

    const PRIMARY_MAIN = theme.palette.primary.main;

    const PRIMARY_DARK = theme.palette.primary.dark;

    const logoImage = (getServerName() === 'Examico') ? logoHeaderExamico : logoHeader;

    const logo = (
      <Box
        component="img"
        src={logoImage}
        sx={{ width: width || 200, cursor: 'pointer', ...sx }}
      />
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Badge
        sx={{
          [`& .${badgeClasses.badge}`]: {
            top: 32,
            right: 7,
          },
        }}
        badgeContent={
          <Link
            underline="none"
            sx={{ ml: 1 }}
          >
            <Label color="info" sx={{ textTransform: 'unset', height: 22, px: 0.5 }}>
              BETA
            </Label>
          </Link>
        }
      >
        <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
          {logo}
        </Link>
      </Badge>
    );
  }
);

export default Logo;
